import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportGetCollection, ReportGetCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportGetCollectionResponse, ReportGetCollectionResponse>) => {
    return response?.data?.data;
}
const getError = (response?: SWRResponse<ReportGetCollectionResponse, ReportGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ReportGetSummaryCollectionByProjectIdResponse, ReportGetSummaryCollectionByProjectIdResponse>) => ({});

const useReports = (configuration?: SWRConfiguration<ReportGetCollectionResponse, ReportGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ReportGetCollection();
        };
    }, [configuration])

    return useGet(request, { getData, getError }, configuration);
}

export default useReports;